<div *ngIf="true">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
    </ng-template>

    <ng-template pTemplate="right">
      <p-button label="Сбросить фильтр" icon="pi pi-undo" styleClass="p-button-success" class="mr-2 hide-label" (onClick)="clearOrResetTableFilter($event)" pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>
      <p-button label="Обновить" icon="pi pi-refresh" styleClass="p-button-success" class="mr-2 hide-label" (onClick)="onReloadAllData($event)" pTooltip="Обновить список документов" tooltipPosition="top"></p-button>
      <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info" class="mr-2 hide-label" (onClick)="onExportData()" [disabled]="!canExport" pTooltip="Экспортировать список документов" tooltipPosition="top"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table #dt
           [value]="dlCurr"
           [lazy]="true"
           (onLazyLoad)="loaddl($event)"
           [loading]="loading"
           [rows]="rows"
           [rowsPerPageOptions]="[10,25,50,100]"
           [showCurrentPageReport]="true"
           [totalRecords]="totalRecords"
           [paginator]="true"
           paginatorPosition="both"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           [filterDelay]="300"
           [globalFilterFields]="['ALL','CLIENTSNAME','DOCNOTE1','DOCNOTE2','PERSONNAME']"
           (onFilter)="handleFilter($event)"
           dataKey="DOCID"
           selectionMode="single"
           [(selection)]="selectedDocument"
           [rowHover]="true"
           stateStorage="local"
           stateKey="clientDocumentList-state"
           (onStateRestore)="onStateRestore($event)"
           rowExpandMode="single"
           [resizableColumns]="true"
           columnResizeMode="fit"
           [tableStyle]="{ 'min-width': '100rem' }">

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn style="width: 4rem"></th>
        <th pResizableColumn style="width: 10% !important">Документ <p-sortIcon field="DOCNAME"></p-sortIcon></th>
        <th pResizableColumn style="width: 12rem !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
        <th pResizableColumn style="width: 10rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
        <th pResizableColumn style="width: 5% !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
        <th pResizableColumn style="width: 5% !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
        <th pResizableColumn style="width: auto !important">Контрагент <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
        <th pResizableColumn style="width: 8rem !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
        <th pResizableColumn style="width: 8rem !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
        <th pResizableColumn style="width: 8rem !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
        <th pResizableColumn style="width: 5% !important" class="do-not-overlay-text">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
        <th pResizableColumn style="width: 5% !important" class="do-not-overlay-text">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
      </tr>
      <tr>
        <th style="width: 4rem"></th>
        <th style="overflow: visible !important; ">

          <p-multiSelect #dst [options]="docTypes" placeholder="Все документы" (onChange)="onDocTypeChange($event)" (onSelectAllChange)="onAllDocTypeChange($event)" [(ngModel)]="selectedDocTypes"
                         [showToggleAll]="true"
                         [selectAll]="selectAllTypes"
                         styleClass="p-column-filter p-dropdown-filter-style" optionLabel="DOCNAME1" maxSelectedLabels="1" selectedItemsLabel="{0} документов выбрано" dataKey="DOCTYPEID">
          </p-multiSelect>
        </th>
        <th style="overflow: visible !important; ">
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск"
                 [(ngModel)]="documentNumberFilter"
                 class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentNumberFilter">
        </th>
        <th style="overflow: visible !important; ">
          <p-calendar [(ngModel)]="filterDate"
                      selectionMode="range"
                      [readonlyInput]="true"
                      showButtonBar="true"
                      selectOtherMonths="true"
                      hideOnDateTimeSelect="true"
                      [firstDayOfWeek]="1"
                      [minDate]="doclistDateRange[0]"
                      [maxDate]="doclistDateRange[1]"
                      showWeek="true"
                      dateFormat="dd/mm"
                      firstDayOfWeek="1"
                      inputId="filter-range"
                      inputStyleClass="p-dropdown-calendar-style"
                      styleClass="p-column-filter"
                      panelStyleClass="p-dropdown-filter-style"
                      (onSelect)="onDateRangeChange( $event)"
                      (onClearClick)="onDateRangeClear( $event)"
                      (onTodayClick)="onTodayClick( $event)">
          </p-calendar>
        </th>
        <th style="overflow: visible !important; ">
          <p-multiSelect [options]="sellerCompany" placeholder="Наши компании" (onChange)="onSellerChange($event)" (onSelectAllChange)="onAllSellerChange($event)"
                         [showToggleAll]="true"
                         [selectAll]="selectAllCompanies"
                         [(ngModel)]="selectedSellerCompany"
                         styleClass="p-column-filter p-dropdown-filter-style" optionLabel="CLIENTSNIKNAME" [maxSelectedLabels]="1"
                         selectedItemsLabel="{0} компаний выбрано" dataKey="CLIID">
          </p-multiSelect>
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск"
                 [(ngModel)]="documentAuthorFilter"
                 class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentAuthorFilter">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск"
                 [(ngModel)]="documentCompanyFilter"
                 class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentCompanyFilter">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCSUM', 'gt')" [(ngModel)]="documentDOCSUMFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentDOCSUMFilter"
                 pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'PAYDSUM', 'gt')" [(ngModel)]="documentPAYDSUMFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentPAYDSUMFilter"
                 pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'SHIPSUM', 'gt')" [(ngModel)]="documentSHIPSUMFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentSHIPSUMFilter"
                 pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск"
                 [(ngModel)]="documentNote1Filter"
                 class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentNote1Filter">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск"
                 [(ngModel)]="documentNote2Filter"
                 class="p-column-filter p-dropdown-filter-style" [class.hasvalue]="documentNote2Filter">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dlCurr let-expanded="expanded">
      <tr [pContextMenuRow]="dlCurr"
          [pSelectableRow]="dlCurr"
          [class.futuredocs]="dlCurr.fd"
          [class.grayout]="dlCurr.go"
          [class.underline]="dlCurr.ps"
          [class.strikeout]="dlCurr.fs"
          [class.partiallypaiddoc]="dlCurr.pp"
          [class.notpaiddoc]="dlCurr.np"
          [class.fullypaiddoc]="dlCurr.fp"
          [class.todaydocuments]="dlCurr.td"
          [class.proformadoc]="(dlCurr.DOCTYPEID == 12)"
          [class.inorderdoc]="(dlCurr.DOCTYPEID == 2)"
          [class.banktransferdoc]="(dlCurr.DOCTYPEID == 9)"
          [class.purchorderdoc]="(dlCurr.DOCTYPEID == 10)"
          [class.yellowdoc]="(dlCurr.DOCTYPEID == 14)"
          [class.specdoc]="(dlCurr.DOCTYPEID == 7)"
          [class.shiporderdoc]="(dlCurr.DOCTYPEID == 4)"
          [class.invoicedoc]="(dlCurr.DOCTYPEID == 1)">
        <td>
          <button type="button" pButton pRipple [pRowToggler]="dlCurr" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td>{{dlCurr.DOCNAME}}</td>
        <td>
          <a [routerLink]="['/edit-document', dlCurr.DOCTYPEID, dlCurr.DOCID]">{{dlCurr.DOCNUMBER}}</a>
        </td>
        <td class="CellWithComment" style="">
          <span class="CellComment">{{dlCurr.DOCVALDATE | date:'dd.MM.yyyy'}}<br />{{dlCurr.DOCEXPDATE | date:'dd.MM.yyyy'}}</span>{{dlCurr.DOCDATE | date:'dd.MM.yyyy' }}
        </td>
        <td>{{dlCurr.LOCALCOMP}}</td>
        <td>{{dlCurr.AUTHOR}}</td>

        <td class="CellWithComment" *ngIf="!showFullNameColumn">
          <span class="CellComment">{{dlCurr.CLIENTSNAME}}</span>
          <a [routerLink]="['/edit-client', dlCurr.DOCCLIENTSID]">{{dlCurr.PARTNERNAME}}</a>
        </td>

        <td class="CellWithComment" *ngIf="showFullNameColumn">
          <span class="CellComment">{{dlCurr.CLIENTSNAME}}</span>
          <a [routerLink]="['/edit-client', dlCurr.DOCCLIENTSID]">{{dlCurr.PARTNERNAMESTR}}</a>
        </td>
        <td style="text-align: right">{{dlCurr.DOCSUM | number:'1.2-2'}}</td>
        <td style="text-align: right">{{dlCurr.PAYDSUM | number:'1.2-2' }}</td>
        <td style="text-align: right">{{dlCurr.SHIPSUM | number:'1.2-2' }}</td>
        <td><input pInputText type="text" [(ngModel)]="dlCurr.DOCNOTE1" [style]="{'padding':'0.25rem'}" readonly alt="{{dlCurr.DOCNOTE1}}"></td>
        <td><input pInputText type="text" [(ngModel)]="dlCurr.DOCNOTE2" [style]="{'padding':'0.25rem'}" readonly alt="{{dlCurr.DOCNOTE2}}"></td>
        <!--<td style="">{{dlCurr.DOCNOTE1}}</td>
        <td style="">{{dlCurr.DOCNOTE2}}</td>-->
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-dlCurr>
      <tr>
        <td colspan="13">
          <app-document-content-table [selectedDocumentId]="dlCurr.DOCID" [showFooterTotal]="true"></app-document-content-table>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="13">Документов не найдено</td>
      </tr>
    </ng-template>
  </p-table>
</div>
